// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.router-link-active[data-v-53cc84dd] {\n  border-bottom: unset;\n  padding-bottom: unset;\n}\n", ""]);
// Exports
module.exports = exports;
